/* eslint-disable @wordpress/no-global-event-listener */
/**
 * SASS
 */
import '../sass/frontend.scss';

/**
 * JavaScript
 */

/**
 * Add here your JavasScript code
 */
var MOPA = {};
document.addEventListener('DOMContentLoaded', function () {
  MOPA.membership = {
    init: function init() {
      if (document.querySelector('.members__membership-modal-trigger')) {
        this.show();
        this.close();
      }
    },
    show: function show() {
      [].forEach.call(document.querySelectorAll('.members__membership-modal-trigger'), function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var title = trigger.getAttribute('data-title');
          document.querySelector(".members__membership-modal[data-title=\"".concat(title, "\"]")).classList.add('visible');
        });
      });
    },
    close: function close() {
      [].forEach.call(document.querySelectorAll('.members__membership-modal .mopa-popup__close'), function (close) {
        close.addEventListener('click', function () {
          close.parentNode.parentNode.classList.remove('visible');
        });
      });
    }
  };
  MOPA.membership.init();
  MOPA.popups = {
    init: function init() {
      if (document.querySelector('.mopa-popup[data-config]')) {
        this.popups = Array.from(document.querySelectorAll('.mopa-popup[data-config]'));
        this.show();
        this.close();
        this.setOverflow();
      }
    },
    show: function show() {
      var _this = this;
      this.popups.forEach(function (popup) {
        var _document$cookie$matc;
        var config = JSON.parse(popup.getAttribute('data-config'));
        var cookie = ((_document$cookie$matc = document.cookie.match('(^|;)\\s*' + "mopapop".concat(config.id) + '\\s*=\\s*([^;]+)')) === null || _document$cookie$matc === void 0 ? void 0 : _document$cookie$matc.pop()) || '';
        if (cookie) {
          return;
        }
        if (config.trigger === 'onload') {
          _this.trigger(popup, config);
        } else if (config.trigger === 'timeout') {
          window.setTimeout(function () {
            _this.trigger(popup, config);
          }, parseInt(config.timeout) * 1000);
        } else if (config.trigger === 'scroll') {
          window.addEventListener('scroll', function () {
            if (window.scrollY > parseInt(config.scroll)) {
              _this.trigger(popup, config);
            }
          });
        } else if (config.trigger === 'exit') {
          document.addEventListener('mouseout', function (e) {
            if (!e.toElement && !e.relatedTarget) {
              _this.trigger(popup, config);
            }
          });
        }
      });
    },
    trigger: function trigger(popup, config) {
      popup.classList.add('visible');
      if (config.frequency > 0) {
        var expires = '';
        var date = new Date();
        date.setTime(date.getTime() + config.frequency * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
        document.cookie = "mopapop".concat(config.id, "=").concat(config.id).concat(expires, "; path=/");
      }
    },
    close: function close() {
      this.popups.forEach(function (popup) {
        var close = popup.querySelector('.mopa-popup__close');
        close.addEventListener('click', function () {
          close.parentNode.parentNode.remove();
        });
      });
    },
    setOverflow: function setOverflow() {
      this.popups.forEach(function (popup) {
        var textWrapper = popup.querySelector('.mopa-popup__text-wrapper');
        var textInner = popup.querySelector('.mopa-popup__text-inner');
        var window80vh = window.innerHeight * 0.8;
        if (!textWrapper || !textInner) return;
        var textWrapperHeight = textWrapper.clientHeight;
        var textInnerHeight = textInner.clientHeight;
        if (textWrapperHeight >= textInnerHeight) return;
        popup.querySelector('picture').style.paddingBottom = Math.min(window80vh, textInner.clientHeight + 50) + 'px';
        textInner.style.height = '100%';
        textInner.style.overflow = 'scroll';
        textInner.style.justifyContent = 'flex-start';
        textInner.style.paddingTop = '4rem';
        textInner.style.paddingBottom = '4rem';
      });
    }
  };
  MOPA.popups.init();
});
window.addEventListener('load', function () {
  MOPA.quicklink = {
    init: function init() {
      var s = document.createElement('script');
      var r = false;
      var t = document.getElementsByTagName('script')[0];
      s.type = 'text/javascript';
      s.src = '/wp-content/themes/mopa/assets/public/js/quicklink.umd.js';
      s.onload = s.onreadystatechange = function () {
        if (!r && (!this.readyState || this.readyState === 'complete')) {
          r = true;
          // eslint-disable-next-line no-undef
          quicklink.listen();
        }
      };
      t.parentNode.insertBefore(s, t);
    }
  };
  MOPA.quicklink.init();
});